export default {
    SET_EXPIRE(state, date) {
        localStorage.setItem("expire", date);
    },
    SET_FINGERPRINT(state, fingerprint) {
        localStorage.setItem("finger", fingerprint);
    }

}
